module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-elle-hughes-2696064-small-56e6e1448c5a8d3812d370da524a67b8.jpg";